import "./Horizantal.css";

const Horizontal = () => {
  return <div className="w-[90%] my-5 h-1 bg-black/20 mx-auto"></div>;
};

export default Horizontal;
